import { useGetCurrentCompany } from '@web/api/company/use-get-company';
import { useEffect } from 'react';
import { useAppSelector } from '../redux/store';
import { selectBuildType, selectUserDataForPendo } from './../redux/selectors/index';
import { initialize } from './analyticsClient';

function useCompanyPendoData() {
  const { data: company } = useGetCurrentCompany();
  const {
    allowNegativeHours = null,
    id = '',
    intacctCompanyId = '',
    mfaRequired = null,
    name = '',
    tenantType = null,
    timesheetDuration = null,
    workdayHours = '',
  } = company ?? {};
  return { allowNegativeHours, id, intacctCompanyId, mfaRequired, name, tenantType, timesheetDuration, workdayHours };
}

export default function useIdentify() {
  const userDataForPendo = useAppSelector(selectUserDataForPendo);
  const companyDataForPendo = useCompanyPendoData();
  const buildType = useAppSelector(selectBuildType);

  useEffect(() => {
    if (userDataForPendo?.id && companyDataForPendo?.id) {
      // The .identify method of pendo doesn't allow to pass in extra data, so we use the .initialize instead
      const visitor = {
        ...userDataForPendo,
        buildType,
      };
      initialize({
        visitor,
        account: companyDataForPendo,
        excludeAllText: true,
      });
    }
  }, [userDataForPendo, companyDataForPendo, buildType]);
}
